import dynamic from 'next/dynamic';

import { useBrand } from '@atc/brand';
import { useFeature } from '@atc/features';

const AtcHeader = dynamic(() => import('@/components/AtcHeader/index.js'), {});
const KBBHeader = dynamic(() => import('@/components/KBBHeader/index.js'), {});
const FordHeader = dynamic(() => import('@/components/FordHeader/index.js'), {});
const DemoHeader = dynamic(() => import('@/components/DemoHeader/index.js'), {});
const CadHeader = dynamic(() => import('@/components/CadHeader/index.js'), {});

export default function AppHeader() {
    const { brand, brands } = useBrand();
    const { ATC_BRAND, KBB_BRAND, FORD_BRAND, DEMO_BRAND, CAR_AND_DRIVER } = brands;

    const [showWallet] = useFeature('my_wallet');

    let BrandedHeader;

    switch (brand) {
        case KBB_BRAND: {
            BrandedHeader = KBBHeader;
            break;
        }

        case FORD_BRAND: {
            BrandedHeader = FordHeader;
            break;
        }

        case DEMO_BRAND: {
            BrandedHeader = DemoHeader;
            break;
        }

        case CAR_AND_DRIVER: {
            BrandedHeader = CadHeader;
            break;
        }

        case ATC_BRAND:
        default: {
            BrandedHeader = AtcHeader;
        }
    }

    return (<BrandedHeader showWallet={showWallet} />);
}
